import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function Doc(props) {
  return (
    <SvgIcon {...props}>
      <path
        fill="currentColor"
        d="M10.8811494,1.66666667 L11.147739,1.75833333 L11.2227173,1.75833333
          C11.308376,1.7984009 11.3871157,1.85184684 11.4559831,1.91666667
          L11.4559831,1.91666667 L16.4545368,6.91666667 C16.5193379,6.98555403
          16.5727684,7.06431646 16.6128244,7.15 L16.6128244,7.15 L16.6128244,7.225
          C16.637377,7.29802548 16.6541322,7.37344575 16.6628099,7.45
          C16.6714876,7.52655425 16.6628099,7.42293273 16.6628099,7.5
          L16.6628099,7.5 L16.6628099,15.8333333 C16.6628099,17.2140452
          15.5438455,18.3333333 14.163533,18.3333333 L14.163533,18.3333333
          L5.83261019,18.3333333 C4.4522977,18.3333333 3.33333333,17.2140452
          3.33333333,15.8333333 L3.33333333,15.8333333 L3.33333333,4.16666667
          C3.33333333,2.78595479 4.4522977,1.66666667 5.83261019,1.66666667
          L5.83261019,1.66666667 L10.8811494,1.66666667 Z M9.99807149,3.33333333
          L5.83261016,3.33333333 C5.37250601,3.33333333 4.9995179,3.70642938
          4.9995179,4.16666667 L4.9995179,4.16666667 L4.9995179,15.8333333
          C4.9995179,16.2935706 5.37250601,16.6666667 5.83261016,16.6666667
          L5.83261016,16.6666667 L14.1635328,16.6666667 C14.623637,16.6666667
          14.9966251,16.2935706 14.9966251,15.8333333 L14.9966251,15.8333333
          L14.9966251,8.33333333 L10.8311638,8.33333333 C10.3710596,8.33333333
          9.99807149,7.96023729 9.99807149,7.5 L9.99807149,7.5 L9.99807149,3.33333333
          Z M11.6642563,4.5083334 L11.6642563,6.66666667 L13.8219653,6.66666667
          L11.6642563,4.5083334 Z"
      />
    </SvgIcon>
  );
}
